/* eslint-disable max-len */
import { jitsiLocalStorage } from '@jitsi/js-utils';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { accountService, callService2, meetService } from '../../../../../service';
import { STATUS } from '../../../../../socket/config';
import { SocketContext } from '../../../../../socket/socket.context';
import { goToPage, goToRoomWithToken } from '../../../../../utils';
import { appNavigate } from '../../../app/actions';
import { conferenceFailed } from '../../../base/conference';
import { callAfterInitiateConference } from '../../../panther/actions.any';
import { startScreenShareFlow } from '../../../screen-share';
import NumericKeyPad from '../../web/organisms/NumericKeyPad';
import ListVideo from '../organisms/ListVideo';
import PhoneBook from '../organisms/PhoneBook';
import { Settings } from '../organisms/Settings';
import UserList from '../organisms/UserList';


interface MenuNavigatorPopupProps {
    menuActive: string,
    openSchedCall: () => void,
    closeSchedCall: () => void,
    openAddContact?: () => void,
    openRecentCall?: () => void,
    openCreateGroup?: () => void,
    addContactList?: Array,
    dataNewGroup?: Array,
    onHandleLogOut?: () => void,
    toggleMenuPopup: () => void,
}
export const MenuNavigatorPopup: React.FC<MenuNavigatorPopupProps> = props => {
    const { isOpenMenu, menuActive, openSchedCall, openAddContact, openCreateGroup, dataNewGroup, toggleMenuPopup, selectedUserList, addContactList } = props;
    const { sendUserStatus } = useContext(SocketContext);
    const [ menuHeight, setMenuHeight ] = useState(25);
    const { user } = useSelector(state => state['features/settings']);
    const { conference } = useSelector(state => state['features/base/conference']);
    const isMobile = useMemo(() => window.innerWidth <= 780, [ window.innerWidth ]);
    const isChangeMode = useMemo(() => !isMobile && isOpenMenu, [ isMobile, isOpenMenu ]);

    const { room } = useSelector(state => {
        return {
            room: state['features/base/conference'].room
        };
    });
    const dispatch = useDispatch();
    const handleInvite = () => {
        dispatch(startScreenShareFlow(true));
    };
    const handleOpenSched = (list, isSuggest, from = 'contacts') => {
        if (from === 'contacts') {
            const selectList = Object.values(list)?.filter(item => item.isContact);

            if (isSuggest) {
                openSchedCall(list);
            } else {
                // console.log(selectList);
                openSchedCall(selectList);
            }
        } else if (from === 'recent') {
            let extractList = [];
            // eslint-disable-next-line array-callback-return
            const selectList = list?.filter(item => {
                if (item?.isContact) {
                    if (item.contacts && item.contacts.length > 0) {
                        extractList = extractList.concat(item.contacts);
                    }
                    if (item.groups && item.groups.length > 0) {
                        extractList = extractList.concat(item.groups);
                    }


                }
            });

            // console.log(extractList);
            openSchedCall(extractList);
        }


    };
    const handleSubmit = async number => {
        if (conference) {
            await callService2.addUserFromNumberIntoCall(room, number)
            .then(async res => {
                const phoneNumber = res.data?.callingHistory?.receivers.slice(-1)[0].phoneNumber;

                await conference.dial(`${phoneNumber}`);


            });
        } else {
            await callService2.createUserCallByPhone(number)
            .then(async res => {
                const phoneNumber = res.data?.callingHistory?.receivers[0].phoneNumber;

                sessionStorage.setItem(`room=${res.data?.callingHistory?.id}`, phoneNumber);
                const meeting = await meetService.createMeeting(res?.data?.callingHistory?.id, `${user.firstName} ${user.lastName}`, user.email, user.id);
                const meetingrest = await meetService.getMeetingData(meeting?.data?.id);


                // goToPage(`home?room=${res.data?.callingHistory?.id}`);
                goToRoomWithToken(meetingrest.authRoom, meetingrest.token);
            });
        }

        toggleMenuPopup();
    };
    const handleLogOut = () => {
        sendUserStatus(user.id, STATUS.OFFLINE);
        jitsiLocalStorage.removeItem('token');
        goToPage('/');
    };

    const getContact = async () => {
        const res = await accountService.getDataContact();

        dispatch({
            type: 'USER_CONTACT',
            value: res
        });
    };

    useEffect(() => {
        getContact();
    }, []);

    useEffect(() => {
        setMenuHeight(document.getElementsByClassName('menu-and-sched-call')[0].offsetHeight);
    }, [ isOpenMenu ]);

    const styleMenuLayout = {
        marginTop: isMobile ? menuHeight : 0,
        marginLeft: isChangeMode && 0
    };

    return (
        <div
            className = { 'a-menu-navigator-popup' }
            style = { styleMenuLayout }>
            {menuActive === 'numbers' && <div className = { 'a-menu-navigator-popup-numbers' }>
                <NumericKeyPad
                    onOpenRecentCall = { () => setIsOpenRecentCall(true) }
                    onSubmit = { value => handleSubmit(value) } />
            </div>}
            {menuActive === 'contact' && <div>
                <PhoneBook
                    addContactList = { addContactList }
                    dataNewGroup = { dataNewGroup }
                    onSubmit = { handleOpenSched }
                    openAddContact = { openAddContact }
                    openCreateGroup = { openCreateGroup }
                    selectedUserList = { selectedUserList } />
            </div>}
            {menuActive === 'share' && <div>
                <ListVideo onChange = { handleInvite } />
            </div>}
            {menuActive === 'recent-call' && <div>
                <UserList
                    onChange = { handleOpenSched }
                    openCreateGroup = { openCreateGroup } />
            </div>}
            {menuActive === 'setting' && <div>
                <Settings
                    onHandleLogOut = { handleLogOut } />
            </div>}
        </div>
    );
};
